









import { Vue, Component } from 'vue-property-decorator'
import { TitleBlockModel } from '../models'
import TitleBlock from '../components/TitleBlock.vue'
import InfoBottom from '../components/InfoBottom.vue'

@Component({
  components: {
    TitleBlock,
    InfoBottom
  }
})

export default class BlockBottom extends Vue {
  titles: TitleBlockModel = {
    title: 'WB Партнеры',
    subtitle: 'Зарегистрируйтесь как самозанятый вместе с&nbsp;Wildberries и&nbsp;начинай продавать товары на&nbsp;самой крупной интернет площадке #1&nbsp;в России.'
  }
}
